import { useSyncExternalStore } from "react";
import type { ReadonlyObservable } from "@/lib/studio/observable";

export function useObservable<T>(obs: ReadonlyObservable<T>): T {
  return useSyncExternalStore(
    (cb) => obs.subscribe(cb),
    () => obs.value,
    () => obs.value,
  );
}
